import { NotFound } from 'fejl'
import { collection } from '@/infra/collection'
import { type Observable } from 'rxjs'
import { type User } from '@/features/iam/users/User'
import { type PayoutsApi } from '@/features/payouts/api/pro-api'
import { PayoutMethod } from './PayoutMethod'
import { mapPayoutMethodResourceToProps } from './payout-method-mappers'
import { Id } from '@/infra/id'

/**
 * Manage payout methods.
 */
export class PayoutMethodStore {
  /**
   * Collection of payout methods.
   */
  readonly payoutMethods = collection({
    getDataId: (d) => d.id,
    getModelId: (m) => m.id,
    create: () => new PayoutMethod(),
  })

  constructor(
    private readonly _currentUser$: Observable<User>,
    private readonly _api?: PayoutsApi,
  ) {
    this._currentUser$.subscribe(() => this.payoutMethods.clear())
  }

  /**
   * Fetches payout method for a user using BigMoney API.
   */
  async fetchPayoutMethod(userPublicId: Id, signal?: AbortSignal) {
    return this._api
      ? this._api.payoutMethods
          .getByUserPublicId(Id.assert(userPublicId), signal)
          .then((resource) =>
            this.payoutMethods.set(mapPayoutMethodResourceToProps(resource)),
          )
          .catch(NotFound.ignore(null))
      : null
  }

  /**
   * Connects the user's Stripe account using the OAuth callback code.
   */
  async connectStripe(userPublicId: Id, code: string) {
    return this._api
      ? this._api.payoutMethods.connectStripe(Id.assert(userPublicId), code)
      : null
  }
}
